import {axiosGet} from "../../../Helpers/AxiosHelper";

const state = {
    zalList: [],
};
const getters = {
    getZal: state => state.zalList

};

const mutations = {
    ZAL_INFO(state, data) {
        state.zalList = data
    }
};

const actions = {
    getZal({commit}) {
        axiosGet(`crm/zal/list`).then((response) => {
            commit('ZAL_INFO', response.data)
        }).catch((error) => console.log(error));
    }
};


export default {
    state,
    getters,
    mutations,
    actions
}
